<script setup>
import { ref, reactive, nextTick } from 'vue'
import DialogModal from './DialogModal.vue'
import LoadingButton from '@/Shared/LoadingButton'
import axios from 'axios'

const emit = defineEmits(['confirmed', 'cancel'])

const props = defineProps({
  title: {
    type: String,
    default: 'applicant.duplicate.possible',
  },
  content: {
    type: String,
    default: 'applicant.duplicate.content',
  },
  confirmationText: {
    type: String,
    default: 'applicant.duplicate.confirmation',
  },
  button: {
    type: String,
    default: 'applicant.duplicate.confirm',
  },
  firstName: {
    type: String,
    required: true,
  },
  lastName: {
    type: String,
    required: true,
  },
})

const confirmingDuplicate = ref(false)

const form = reactive({
  password: '',
  error: '',
  processing: false,
  duplicates: [],
})

const startConfirmingDuplicate = () => {
  const first_name = props.firstName
  const last_name = props.lastName
  axios.get('/applicants/check-duplicate?first_name=' + first_name + '&last_name=' + last_name)
    .then(res => {
      if (res.data.length === 0) {
        emit('confirmed')
      } else {
        form.duplicates = res.data
        confirmingDuplicate.value = true
      }

      //
    })
}

const confirmDuplicate = () => {
  form.processing = true
  form.processing = false
  closeModal()
  nextTick().then(() => emit('confirmed'))
}

const closeModal = () => {
  confirmingDuplicate.value = false
  nextTick().then(() => emit('cancel'))
  form.password = ''
  form.error = ''
}

const columns = [
  {
    label: 'Name',
    field: 'name',
  },
]


</script>

<template>
  <span>
    <span @click="startConfirmingDuplicate">
      <slot />
    </span>

    <DialogModal :show="confirmingDuplicate" @close="closeModal">
      <template #title>
        {{ $t(title) }}
      </template>

      <template #content>
        {{ $t(content) }}
        <div class="mt-4">
          <ul class="list-disc ml-4">
            <li v-for="item in form.duplicates" :key="item.id" class="mb-3">
              <a
                :href="'/applicants/' + item.id + '/view'" style="text-decoration: underline"
                target="_blank"
                class="text-indigo-500"
              >
                {{ item.first_name }} {{ item.last_name }}
              </a>
            </li>
          </ul>

          {{ $t(confirmationText) }}
        </div>
      </template>

      <template #footer>
        <button
          class="hover:underline" tabindex="-1" type="button"
          @click="closeModal"
        >{{ $t('global.cancel') }}
        </button>

        <LoadingButton
          :loading="form.processing"
          class="btn-indigo ml-auto" type="submit"
          @click="confirmDuplicate"
        >
          {{ $t(button) }}
        </LoadingButton>
      </template>
    </DialogModal>
  </span>
</template>
